import CountdownLabel from '/helpers/CountdownLabel.jsx';
import Link from "next/link";
import {DateTime} from 'luxon';
import {activeTimeTableItem, nextUpcomingTimeTableItem, toTime, upcomingMsgForItem, activeMsgForItem} from '/utils';
import {ROOM_FOR_CATEGORY, LABEL_FOR_CATEGORY} from '/components/shared/constants';

export default function EnjoyTheShow({show}) {
    let item = activeTimeTableItem(show.timetable);
    let msg = '';
    if (item) {
        msg = activeMsgForItem(item);
    } else {
        item = nextUpcomingTimeTableItem(show.timetable);
        if (item) {
            msg = upcomingMsgForItem(item);
        } else {
            msg = `Die Veranstaltung ist leider vorbei.`;
        }
    }

    return (
        <div
          className="flex flex-col justify-center items-center py-12 px-20 bg-black bg-opacity-20 backdrop-filter backdrop-blur-[12px] rounded-2xl">
          <h3 className="transition-transform text-white mb-6 text-4xl text-center w-full">
            {msg}
          </h3>
          {item ? (
              <Link href={ROOM_FOR_CATEGORY[item.category]}>
                <a className="bg-gold text-white px-6 py-3 text-sm rounded-full uppercase">
                  {LABEL_FOR_CATEGORY[item.category]}
                </a>
              </Link>
          ) : null}
        </div>
    );
}
